import { render, staticRenderFns } from "./logisticsPortal.vue?vue&type=template&id=0930c3f3&scoped=true"
import script from "./logisticsPortal.vue?vue&type=script&lang=js"
export * from "./logisticsPortal.vue?vue&type=script&lang=js"
import style0 from "./logisticsPortal.vue?vue&type=style&index=0&id=0930c3f3&prod&lang=css"
import style1 from "./logisticsPortal.vue?vue&type=style&index=1&id=0930c3f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930c3f3",
  null
  
)

export default component.exports